import { UserRoles } from '@/constants/users';

const isEmployee = (user) => {
  return UserRoles.EMPLOYEE === user?.role;
};

export default isEmployee;
